export const SET_COUPONS = 'SET_COUPONS';
export const SET_COUPON = 'SET_COUPON';
export const SET_COUPON_ID = 'SET_COUPON_ID';
export const SET_COUPON_USAGE = 'SET_COUPON_USAGE';
export const REMOVE_COUPON = 'REMOVE_COUPON';
export const REMOVE_COUPON_ID = 'REMOVE_COUPON_ID';
export const SET_PAYNOW_COUPON_FEATURE = 'SET_PAYNOW_COUPON_FEATURE';


// WEBPACK FOOTER //
// ./src/store/modules/coupons/mutations.js